import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1B365D] text-white noise-overlay" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-4" data-testid="footer-company-name">
              POWER TECH <span className="text-[#F97316]">ENGINEERS</span>
            </h3>
            <p className="text-slate-300 text-sm leading-relaxed">
              Your trusted partner for reliable diesel generator solutions from 5 kVA to 250 kVA.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <Link to="/" className="block text-slate-300 hover:text-[#F97316] transition-colors text-sm" data-testid="footer-link-home">
                Home
              </Link>
              <Link to="/about" className="block text-slate-300 hover:text-[#F97316] transition-colors text-sm" data-testid="footer-link-about">
                About Us
              </Link>
              <Link to="/products" className="block text-slate-300 hover:text-[#F97316] transition-colors text-sm" data-testid="footer-link-products">
                Products
              </Link>
              <Link to="/services" className="block text-slate-300 hover:text-[#F97316] transition-colors text-sm" data-testid="footer-link-services">
                Services
              </Link>
              <Link to="/contact" className="block text-slate-300 hover:text-[#F97316] transition-colors text-sm" data-testid="footer-link-contact">
                Contact
              </Link>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li>Generator Sales</li>
              <li>Installation & Commissioning</li>
              <li>Annual Maintenance (AMC)</li>
              <li>Repair & Troubleshooting</li>
              <li>Emergency Support 24/7</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-[#F97316] mt-1 flex-shrink-0" />
                <a 
                  href="https://maps.app.goo.gl/Vnrsa2DwJk3sGYoA6" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-300 hover:text-[#F97316] transition-colors"
                >
                  Mysore, Karnataka, India
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-[#F97316] flex-shrink-0" />
                <a 
                  href="tel:+917760180840" 
                  className="text-slate-300 hover:text-[#F97316] transition-colors"
                  data-testid="footer-phone"
                >
                  +91 7760180840
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={18} className="text-[#F97316] flex-shrink-0" />
                <a 
                  href="mailto:powertechgeneratorsmysore@gmail.com" 
                  className="text-slate-300 hover:text-[#F97316] transition-colors"
                  data-testid="footer-email"
                >
                  powertechgeneratorsmysore@gmail.com
                </a>
              </div>
            </div>
            <div className="flex gap-4 mt-6">
              <a href="#" className="text-slate-300 hover:text-[#F97316] transition-colors" data-testid="social-facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-slate-300 hover:text-[#F97316] transition-colors" data-testid="social-twitter">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-slate-300 hover:text-[#F97316] transition-colors" data-testid="social-linkedin">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-slate-300 hover:text-[#F97316] transition-colors" data-testid="social-instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-600 mt-12 pt-8 text-center text-sm text-slate-400">
          <p>&copy; {currentYear} Power Tech Engineers. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};